//config
const Review_card=[
{
    content:"I really like the atmosphere, good coffee, and nice interior. The drinks and foods were all tasty and worthwhile. If you’re up for a fresh place with beautiful architecture then this is a must to visit.",
    img:'https://wallpapercave.com/wp/wp6311937.jpg ',
    title:'Mruganka Chiplunkar'
},
{
    content:"This place is amazing! They offered the best coffee and showed the best attitude to its costumers. Internet connection is very fast and is unlimited as well.  I just want to keep coming back to this place. Thank you!",
    img:'https://yt3.ggpht.com/a/AATXAJxRceq5uCXWjFmQnpPytOk45REEPss7CJWoRg=s900-c-k-c0xffffffff-no-rj-mo',
    title:'Om Nandurkar',
},
{
    content:" I would probably say that this coffee shop is a must for coffee lovers! The service was good, and the variety of coffee served in the ambiance was very satisfying. If you like your coffee shops, then this is a must-visit!",
    img:'https://wallpapercave.com/wp/wp6783850.jpg',
    title:'Archana Ambhure'

},
{
    content:"This coffee shop is my favorite place to hang and do my works. I really like this place because it has a good ambiance and not too crowded as well. The coffee and pastries that they had were so delicious.",
    img:'https://th.bing.com/th/id/OIP.dKNhJAbFBpHCM0YA3lDn8wAAAA?w=358&h=475&rs=1&pid=ImgDetMain',
    title:'Sunny Kumar'
},
{
    content:"This place is very different and well organized according to other places. The food is amazing, music of your choice. The owner is very sweet… Ever the best café.",
    img:'https://wallpapercave.com/wp/wp6127535.jpg',
    title:'Dhumal Vaishnavi'
},
{
    content:" This coffee shop has it all. The ambiance, interior designs, good coffee, tasty foods, and fast wi-fi connection. . It is simply one of the best and my favorites coffee shop in town. ",
    img:'https://th.bing.com/th/id/OIP.KC7BQ-odnvK6ZUM_lLzyRgHaE6?rs=1&pid=ImgDetMain',
    title:'Sadanand Gurude'
},
{
    content:"Great staff, great owner, great coffee. The atmosphere is cozy and nice, certainly my absolute favorite go-to spot as a local. I’ve gone here every day for the past three months, every single cup of coffee hits the spot.",
    img:'https://pbs.twimg.com/media/CN-WtV9VEAAP-VU.jpg:large',
    title:"Sanket "
},
{
    content:" This coffee shop has it all. The ambiance, interior designs, good coffee, tasty foods, and fast wi-fi connection. . It is simply one of the best and my favorites coffee shop in town. ",
    img:'https://th.bing.com/th/id/OIP.ol3axgE6DaBtFk6-q_rw7AHaHa?w=600&h=600&rs=1&pid=ImgDetMain',
    title:'Shivam More'
},
{
    content:" This coffee shop has it all. The ambiance, interior designs, good coffee, tasty foods, and fast wi-fi connection. . It is simply one of the best and my favorites coffee shop in town. ",
    img:'https://th.bing.com/th/id/OIP.STLdlBvb0Ef4oS5PNjroXgHaL2?rs=1&pid=ImgDetMain',
    title:'Abhishek Deshmukh'
},]


export{
    Review_card
}